export default [
  { key: 0, label: "日本語", value: "ja-JP", currency: "JPY", money: "¥" },
  { key: 1, label: "English", value: "en-US", currency: "USD", money: "$" },
  { key: 2, label: "简体中文", value: "zh-CN", currency: "CNY", money: "¥" },
  { key: 3, label: "한국어", value: "ko-KR", currency: "KRW", money: "₩" }
];
